import styled from 'styled-components';

const VimeoWrapper = styled.section`
  .vimeoPlayer > iframe {
    @media (max-width: 575px) {
      width: 100% !important;
    }
  }
`;

export default VimeoWrapper;
